export default __webpack_public_path__ + "static/media/car5.26aceed0.jpg";